// bao migrate skip 72b834ac
import * as hasher from "hasher";
import * as $ from "jquery";
import * as ko from "knockout";
import BaoMenu from "./../services/bao-menu";
import Bao from "./../services/bao-service";
import TabPage from "./tab-page";
import BaoDialog from "../factories/bao-dialog";

let countInstances = 0;

export default class TabController implements Factories.TabController {

	public GlobalMode = false;

	public SelectedTab = ko.observable<TabPage>();
	public TabContainer = ko.observable<HTMLElement>();
	public Tabs = ko.observableArray<TabPage>();

	private WindowSizeChanged = ko.observable<Date>();
	private _nextId = 1;
	private _msgPageLeave = ko.observable("Unsaved changes are lost");
	private _msgCloseAllTabsButtonTooltip = ko.observable("Close all saved tabs");
	private _msgCloseAllSavedTabsPrompt = ko.observable("Do you want to close all saved tabs?");
	private _tabSelectionStack = [];

	private closeAllActive = false;

	public Height: KnockoutComputed<number>;
	private ForceMode = false;
	constructor(globalMode?: boolean) {
		if (globalMode === true) {
			this.GlobalMode = globalMode;
		}
		countInstances++;
		this.Height = ko.pureComputed(() => {
			const WindowSizeChanged = this.WindowSizeChanged(); // only for sub
			ko.utils.arrayForEach(this.Tabs(), (t) => {
				const tabTitle = t.TitleComputed(); // only for sub
			});
			return this.CalculateHeight();
		}).extend({
			rateLimit: { method: "notifyWhenChangesStop", timeout: 500 }
		});
		Bao.Session.GetMessage("msgPageLeave", this._msgPageLeave);
		Bao.Session.GetMessage("msgCloseAllTabsButtonTooltip", this._msgCloseAllTabsButtonTooltip);
		Bao.Session.GetMessage("msgCloseAllSavedTabsPrompt", this._msgCloseAllSavedTabsPrompt);

		$(window).resize(() => {
			this.WindowSizeChanged(new Date());
		});
	}

	public CalculateHeight = () => {
		if (this.TabContainer() != null && this.GlobalMode) {
			return $(this.TabContainer()).height() + 5;
		}
		return 0;
	}

	public RefreshTabs = () => {
		const refreshDefArray = [];
		ko.utils.arrayForEach(this.Tabs(), (tab) => {
			if (tab.Loaded() == true && tab.ViewModel() != null && tab.ViewModel().Refresh != null && typeof tab.ViewModel().Refresh == "function") {
				refreshDefArray[refreshDefArray.length] = tab.ViewModel().Refresh();
			}
		});
		return $.when.apply($, refreshDefArray);
	}

	public SaveTabs = (savetime) => {
		const saveDefArray = [];
		ko.utils.arrayForEach(this.Tabs(), (tab) => {
			if (tab.Loaded() == true && tab.ViewModel() != null && typeof tab.ViewModel().Save == "function") {
				if (typeof tab.ViewModel().Commit == "function") {
					saveDefArray[saveDefArray.length] = tab.ViewModel().Commit(savetime);
				} else {
					saveDefArray[saveDefArray.length] = tab.ViewModel().Save(savetime);
				}
			}
		});
		return $.when.apply($, saveDefArray);
	}

	public CommitTabs = (savetime) => {
		const commitDefArray = [];
		ko.utils.arrayForEach(this.Tabs(), (tab) => {
			if (tab.Loaded() == true && tab.ViewModel() != null && typeof tab.ViewModel().Commit == "function") {
				commitDefArray[commitDefArray.length] = tab.ViewModel().Commit(savetime);
			}
		});
		return $.when.apply($, commitDefArray);
	}

	public CompleteCheckTabs = () => {
		const def = $.Deferred();
		const completeCheckDefArray = [];
		let tabCompleteCheckResult = true;
		ko.utils.arrayForEach(this.Tabs(), (tab) => {
			if (tab.Loaded() == true && tab.ViewModel() != null && typeof tab.ViewModel().CompleteCheck == "function") {
				const completeCheck = tab.ViewModel().CompleteCheck();
				if (completeCheck.then != undefined) {
					completeCheckDefArray[completeCheckDefArray.length] = completeCheck;
				} else if (completeCheck === false) {
					tabCompleteCheckResult = false;
				}
			}
		});
		$.when.apply($, completeCheckDefArray).then(function () {
			$.each(arguments, (index, item) => {
				if (item == false) {
					tabCompleteCheckResult = false;
					return false;
				}
			});
			def.resolve(tabCompleteCheckResult);
		});
		return def.promise();
	}

	public AddTab = (newTab) => {
		let tabFound;

		if (newTab.ObjectId() != null) {
			tabFound = this.SearchTabByObjectId(newTab.ObjectId());
		}
		if (tabFound != null) {
			tabFound.TabLoaded = newTab.TabLoaded;
			if (newTab.Route != null) {
				tabFound.Route = newTab.Route;
			}
			if (!Bao.Utils.String.IsNullOrWhitespace(newTab.Url())) {
				tabFound.Url(newTab.Url());
			}
			this.SelectTab(tabFound);
		} else {
			const newId = this._nextId++;
			newTab.$TabController = this;
			newTab.TabAdded(true);
			newTab.LoadingAllowed(true);
			newTab.TabViewModel(this);
			this.Tabs.push(newTab);
			if (newTab.AutoSelect == true) {
				this.SelectTab(newTab);
			}
			if (this.GlobalMode == true) {
				newTab.subscriptions.push(newTab.DirtyFlag.subscribe((isDirty) => {
					if (newTab != null && newTab.IsClosable != null && newTab.EnableDirtyTracking != null &&
						newTab.IsClosable() && newTab.EnableDirtyTracking()) {
						if (isDirty) {
							window.onbeforeunload = this.confirmOnPageExit;
						} else {
							this.DirtyTabsCheck();
						}
					}
				}));
				//Recalculate height on tab title change
				newTab.subscriptions.push(newTab.TitleComputed.subscribe(() => {
					this.CalculateHeight();
				}));
			}
		}
		if (this.GlobalMode) {
			this.CalculateHeight();
		}
	}

	public DirtyTabsCheck = () => {
		let anyTabDirty = false;
		for (let i = 0; i < this.Tabs().length; i++) {
			if (this.Tabs()[i].DirtyFlag() && this.Tabs()[i] != null && this.Tabs()[i].IsClosable() && this.Tabs()[i].EnableDirtyTracking() == true) {
				anyTabDirty = true;
				break;
			}
		}
		if (anyTabDirty == false) {
			window.onbeforeunload = null;
		}
	}

	public RemoveTab = (tab, e?, closeAllMode?: boolean): JQueryPromise<void> => {
		const def = $.Deferred();
		if (tab.TabUnselected != null) {
			tab.TabUnselected();
		}
		if (this.ForceMode == false && tab != null && tab.ViewModel != null && typeof tab.ViewModel === "function" && tab.ViewModel() != null &&
			tab.ViewModel().BeforeClose != null) {
			this.SelectTab(tab);
			tab.ViewModel().BeforeClose(() => {
				this._removeTab(tab, closeAllMode);
				def.resolve();
			});
		} else {
			this._removeTab(tab, closeAllMode);
			def.resolve();
		}
		if (this.GlobalMode) {
			this.CalculateHeight();
		}
		if (e != null) {
			e.cancelBubble = true;
			e.returnValue = false;
			if (e.stopPropagation) {
				e.stopPropagation();
			}
			if (e.preventDefault) {
				e.preventDefault();
			}
		}
		return def.promise();
	}

	public SelectTab = (tab, event?, forceSetHash?: boolean) => {
		if (tab != null && event != null && tab.Route != null && tab.Route.request != null && this.GlobalMode) {
			hasher.setHash(tab.Route.request);
		} else {
			$.each(this.Tabs(), (index, item) => {
				if (item.IsActiveTab() == true) {
					item.ScrollPosition(Bao.Utils.scrollPosition());
					if (item != tab) {
						item.TabUnselected();
					}
				}
				item.IsActiveTab(false);
			});
			if (tab != null) {
				if (tab.PreLoad() === false) {
					tab.PreLoad(true);
				}
				const lastTab = this.SelectedTab();
				if (tab != lastTab) {
					if (lastTab != null && lastTab.Context() != null) {
						lastTab.Context().Visible(false);
					}
				}
				if (this.GlobalMode) {
					BaoMenu.selectContext(null);
					if (tab.Context() != null) {
						tab.Context().Visible(true);
						BaoMenu.selectContext(tab.Context());

					}
					if (tab.Route == null || tab.Route.request == null) {
						hasher.setHash("");
					}
					if (forceSetHash && tab.Route != null && tab.Route.request != null) {
						hasher.setHash(tab.Route.request);
					}
					document.title = Bao.Session.ApplicationName() + " - " + tab.TitleComputed();
				}
				this.SelectedTab(tab);
				tab.IsActiveTab(true);
				tab.TabSelected();


				//Remove the tab from the selection stack if it already exists
				//and push it to the top of the stack
				const index = this._tabSelectionStack.indexOf(tab);
				if (index > -1) {
					this._tabSelectionStack.splice(index, 1);
				}
				this._tabSelectionStack.push(tab);


				if (tab.ScrollPosition() != null) {
					$(window).scrollTop(tab.ScrollPosition());
				}
			}
		}
	}

	public SelectTabContext = () => {
		if (this.SelectedTab() != null && this.SelectedTab().Context() != null && this.GlobalMode) {
			BaoMenu.selectContext(this.SelectedTab().Context());
		}
		return true;
	}

	public RefreshContext = (tab) => {
		if (this.GlobalMode && tab.Context() != null) {
			BaoMenu.selectContext(tab.Context());
		}
	}

	public SearchTabByObjectId = (objectId) => {
		let tabFound = null;
		if (objectId != null) {
			$.each(this.Tabs(), (index, tab) => {
				if (tab.ObjectId() == objectId) {
					tabFound = tab;
					return;
				}
			});
		}
		return tabFound;
	}

	public SearchTabByObjectIdUrl = (objectId, url) => {
		let tabFound = null;
		if (objectId != null && url != null) {
			$.each(this.Tabs(), (index, tab) => {
				if (tab.ObjectId() == objectId && tab.Url() == url) {
					tabFound = tab;
					return;
				}
			});
		}
		return tabFound;
	}

	public DestroyAll = () => {
		$.each(this.Tabs(), (index, t) => {
			t.destroy();
		});
		this.Tabs([]);
	}

	public CloseAll = (alsoSelected: boolean = false, force = false): JQueryPromise<boolean> => {
		const def = $.Deferred<boolean>();
		this.closeAllActive = true;
		const closeTabs = [];
		this.Tabs().forEach((t) => {
			if (alsoSelected || t.Id() !== this.SelectedTab().Id()) {
				closeTabs.push(t);
			}
		});
		const defs = [];
		this.ForceMode = force;
		if (closeTabs.length > 0) {
			closeTabs.forEach((t) => {
				if (force) {
					defs.push(this.RemoveTab(t, null, true));
				} else {
					defs.push(this.RemoveTab(t));
                }
				//Clear the selection stack
				this._tabSelectionStack.pop();
			});
		}
		this.ForceMode = false;
		$.when.apply(this, defs).then(() => {
			window.location.hash = "";
			this.closeAllActive = false;
			def.resolve(true);
		});
		return def.promise();
	}

	public CloseAllClosable = (value) => {
		var closeTabs = [];
		for (var i = 0; i < this.Tabs().length; i++) {
			if (this.Tabs()[i].IsClosable() && !this.Tabs()[i].DirtyFlag()) {
				closeTabs.push(this.Tabs()[i]);
			}
		}
		if (closeTabs.length > 0) {
			var questionDialog = new BaoDialog(Bao.Session.ApplicationName(), this._msgCloseAllSavedTabsPrompt, "yesno");
			questionDialog.DialogResult.subscribe((result) => {
				if (result === true) {
					Promise.all(closeTabs.map((tab) =>  this.RemoveTab(tab, null, true) ))
						.then(x => this.AutoSelectTab());
                }
			});
		}
	};

	private confirmOnPageExit = (e) => {
		e = e || window.event;
		const message = ko.unwrap(this._msgPageLeave);
		if (e) {
			e.returnValue = message;
		}
		return message;
	}
	private _removeTab = (tab, closeAllMode?: boolean) => {
		if (tab != null) {
			if (this.GlobalMode && tab.Context() != null) {
				BaoMenu.removeContext(tab.Context());
			}
			this.Tabs.remove(tab);
			//Remove the tab from the selection stack
			const index = this._tabSelectionStack.indexOf(tab);
			if (index > -1) {
				this._tabSelectionStack.splice(index, 1);
			}
			tab.destroy();
			//If the tab to close is the current selected tab, open the previously selected tab.
			if (tab.IsActiveTab() && this.Tabs().length > 0) {
				if (!closeAllMode) {
					this.AutoSelectTab();
                }
			}

			tab.IsActiveTab(false);
			this.DirtyTabsCheck();
		}
	}

	/*
	 * Automatically selects the previously selected tab
	 * */
	private AutoSelectTab = () => {
		if (this._tabSelectionStack.length > 0) {
			this.SelectTab(this._tabSelectionStack[this._tabSelectionStack.length - 1], null, true);
		} else {
			this.SelectTab(this.Tabs()[0], null, true);
		}
    }
}
